var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 54.418,
    height: 57.08,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-linked_in_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linked_in_icon",
    "data-name": "linked in icon",
    clipPath: "url(#clip-linked_in_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(-3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M49.294,18.5A18.5,18.5,0,1,1,30.79,0a18.5,18.5,0,0,1,18.5,18.5",
    transform: "translate(-10.213)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M74.552,61.054h3.584V72.567H74.552Zm1.793-5.721a2.075,2.075,0,1,1-2.078,2.073,2.075,2.075,0,0,1,2.078-2.073",
    transform: "translate(-61.735 -45.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M110.5,87.833h3.432v1.575h.047a3.762,3.762,0,0,1,3.389-1.86c3.623,0,4.291,2.383,4.291,5.483v6.314h-3.576v-5.6c0-1.336-.026-3.053-1.86-3.053-1.863,0-2.147,1.454-2.147,2.955v5.695H110.5Z",
    transform: "translate(-91.857 -72.775)",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f7a9b530d1d383eb2ae902afe7de6336.svg";
export { ForwardRef as ReactComponent };